var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4302_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99992 5H34.9999C35.4419 5 35.8659 5.17559 36.1784 5.48816C36.491 5.80072 36.6666 6.22464 36.6666 6.66667V33.3333C36.6666 33.7754 36.491 34.1993 36.1784 34.5118C35.8659 34.8244 35.4419 35 34.9999 35H4.99992C4.55789 35 4.13397 34.8244 3.82141 34.5118C3.50885 34.1993 3.33325 33.7754 3.33325 33.3333V6.66667C3.33325 6.22464 3.50885 5.80072 3.82141 5.48816C4.13397 5.17559 4.55789 5 4.99992 5ZM20.0999 19.4717L9.41325 10.3967L7.25492 12.9367L20.1216 23.8617L32.7566 12.9283L30.5766 10.4067L20.1016 19.4717H20.0999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4302_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailFill);
export default __webpack_public_path__ + "static/media/mail-fill.bb9dbbb2ca8c57fdd398c02995a5765c.svg";
export { ForwardRef as ReactComponent };